import { Component, OnInit } from "@angular/core";
import { HistoricVar, QueryReadings } from "../../devices/device.model";
import { EnergyService } from "../energy.service";
import { DatePipe } from "@angular/common";
import { DevicesService } from "../../devices/devices.service";
import { SharedUtils } from "../../../shared/shared.utils";
import { SessionStateService } from "../../../core/services/session-state.service";
import { GeneralService } from "../../../shared/services/general.service";
import { Device } from "../../devices/devices.model_new";

@Component({
  selector: "app-energy-resume",
  templateUrl: "./energy-resume.component.html",
  styleUrls: ["./energy-resume.component.scss"],
})
export class EnergyResumeComponent implements OnInit {
  SharedUtils = SharedUtils;
  // Values
  totalConsumption = 0;
  powerGridConsumption = 0;
  solarConsumption = 0;
  totalGeneration = 0;
  selfConsumption = 0;
  suppliedToGrid = 0;
  /**Main*/
  graphReadings: QueryReadings;
  selfReadings: QueryReadings;
  injectionReadings: QueryReadings;
  activeView = "day";
  mode = "kWh";
  selectionSeconds = "3600";
  selectedDate: string;
  integrationPeriodType = "0";

  public ChartType = "bar";
  public ChartLabels: string[];
  public ChartLegend = false;
  public ChartData: any[];
  public ChartColors: Array<any>;
  public selectedMoments;
  /**Aux */
  totalValue: number;
  max = new Date(Date.now());
  maxValue = 0;
  currentSelectedDate = new Date(Date.now());
  numberOfTariffs = 1;
  allSchedules = true;
  normalSchedules = true;
  economicSchedules = true;
  superEconomicSchedules = true;
  selfConsumptionSchedules = true;
  supliedtoGridSchedules = true;
  noData = false;
  nextArrowPossible = false;
  previousView: string;
  loading = false;

  smartReaderDevice: Device;
  /**Controls */
  loaded = false;
  /**Chart Options */
  public ChartOptions: any = {
    scaleShowVerticalLines: false,
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: true,
          },
          ticks: { min: 0 },
        },
      ],
    },
  };

  constructor(
    private sessionStateService: SessionStateService,
    private datePipe: DatePipe,
    private devicesService: DevicesService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .subscribe((smartMeter: any) => {
        this.smartReaderDevice = smartMeter[0];
      });
  }

  changeMode(event) {
    this.resetValues();
    this.loading = true;
    this.mode = event;
  }

  changeDate(event) {
    this.resetValues();
    this.loading = true;
  }

  totalsUpdate(event) {
    this.totalConsumption = 0;
    this.totalGeneration = 0;
    if (event[0] === "consumption") {
      if (this.mode === "Eur") {
        this.powerGridConsumption =
          event[1] && event[1].cost.N ? event[1].cost.N : 0;
        this.powerGridConsumption +=
          event[1] && event[1].cost.E ? event[1].cost.E : 0;
        this.powerGridConsumption +=
          event[1] && event[1].cost.SE ? event[1].cost.SE : 0;
      } else {
        this.powerGridConsumption =
          event[1] && event[1].value.N ? event[1].value.N : 0;
        this.powerGridConsumption +=
          event[1] && event[1].value.E ? event[1].value.E : 0;
        this.powerGridConsumption +=
          event[1] && event[1].value.SE ? event[1].value.SE : 0;
      }
    } else if (event[0] === "self") {
      if (this.mode === "Eur") {
        this.selfConsumption =
          event[1] && event[1].cost.D ? event[1].cost.D : 0;
      } else {
        this.selfConsumption =
          event[1] && event[1].value.D ? event[1].value.D : 0;
      }
    } else if (event[0] === "injection") {
      if (this.mode === "Eur") {
        this.suppliedToGrid = event[1] && event[1].cost.D ? event[1].cost.D : 0;
      } else {
        this.suppliedToGrid =
          event[1] && event[1].value.D ? event[1].value.D : 0;
      }
    }
    this.totalGeneration = this.selfConsumption + this.suppliedToGrid;
    this.totalConsumption = this.powerGridConsumption + this.selfConsumption;
    this.solarConsumption = this.selfConsumption;
    const x = setInterval(() => {
      this.loading = false;
      clearInterval(x);
    }, 1000);
  }

  resetValues() {
    this.powerGridConsumption = 0;
    this.suppliedToGrid = 0;
    this.selfConsumption = 0;
    this.totalGeneration = 0;
    this.totalConsumption = 0;
    this.solarConsumption = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-resume/energy-resume.component.ts